import { URLS } from "constants/urls";
import apiRequests from "utils/apiRequests";

export const fetchPortalConfig = (portalSlug) =>
  apiRequests.get(`${URLS.PORTAL}?portal-slug=${portalSlug}`);